import { AsideContent } from "@/kit/ui/aside";
import { Divided, DividedItem } from "./Divided";
import { HostCard, HostCardProps } from "./HostCard";
import TagList, { TagListProps } from "./TagList";
import { FormattedMessage } from "react-intl";
import TableOfContents from "./TableOfContents";
import { TOCItem } from "@/utils/generateToc";

interface ActivityAsideContentProps
  extends HostCardProps, Pick<TagListProps, "taggable"> {
  titles: ReadonlyArray<TOCItem>;
}

function ActivityHostLabel({ activity }: ActivityAsideContentProps) {
  switch (activity) {
    case "EVENT":
      return <FormattedMessage defaultMessage="Challenge host" />;
    case "COMPETITION":
      return <FormattedMessage defaultMessage="Track host" />;
  }
}

export function ActivityAsideContent(props: ActivityAsideContentProps) {
  return (
    <AsideContent>
      <Divided>
        <DividedItem title={<ActivityHostLabel {...props} />}>
          <HostCard
            host={props.host}
            activity={props.activity}
            count={props.count}
          />
        </DividedItem>
        <DividedItem
          title={<FormattedMessage defaultMessage="Tags" />}
          description={<FormattedMessage defaultMessage="Add tags" />}
        >
          <TagList taggable={props.taggable} />
        </DividedItem>
        <DividedItem
          title={<FormattedMessage defaultMessage="Table of contents" />}
        >
          <TableOfContents titles={props.titles} />
        </DividedItem>
      </Divided>
    </AsideContent>
  );
}
